import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Products from '../../../ProductsList/index';

export default () => (
  <Switch>
    <Route exact path="/products" component={Products} />
  </Switch>
);
